import {Presentation, PresentationState} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {WGParsedGameData} from "../../../../server/data/WGParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {InitialWinCountup} from "./InitialWinCountup";
import {WarriorGraveyardGameModuleConfig} from "../../../../WarriorGraveyardGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {WGGameConfig} from "../../../../WGGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IReelSymbolStates, WGSpriteSymbol} from "../../../../engine/Symbol/WGSpriteSymbol";
import {WGEngineManager} from "../../../../engine/WGEngineManager";
import {SoundManager} from "../../../../resource/sound/SoundManager";
import {WarriorGraveyard} from "../../../../WarriorGraveyard";

export class WGInitialWinPresentation extends Presentation {

    private _initialWinData: WGParsedGameData;
    private _winCountup: InitialWinCountup;

    constructor() {
        super();
        this._winCountup = new InitialWinCountup();
        StageManager.getLayer(WGGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountup);
    }

    public checkForActivation(data: WGParsedGameData): boolean {
        return data.singleWin > 0 && data._rawdata.betLineWins!.length > 0;
    }

    public setParsedGamedData(data: WGParsedGameData): void {
        this._initialWinData = data;
        this._winCountup._isCountupAbort = false;

        // #373
        WGGameConfig.instance.WIN_BELOW_STAKE = (WarriorGraveyard.api.gameClientConfiguration.belowStakeWinRestriction && (data.singleWin <= data.playedBetValue));
    }

    public getPresentation(): void {
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
        // play winbox animation on symbol
        let betlineWin = (this._initialWinData.betWins) as IBetLineWinData[];

        // to fix #272
        for (let i = 0; i < 6; i++) {
            if (this._initialWinData.wildMultipliers[i] || this._initialWinData.lockedWildReelsAfter[i]) {
                WGEngineManager.getReel(i).undimWildsOverlay();
            }
        }

        this.pTimeline.add(WarriorGraveyardGameModuleConfig.betlineWinBox.playWinBoxAnimation(betlineWin, this._initialWinData.currentWinRatioConfig?.text, true));
        this.addWinCountupToTimeline();

        // to play initial win sounds
        // #373
        if (!WGGameConfig.instance.WIN_BELOW_STAKE) {
            SoundManager.playInitialWinSound(this._initialWinData.currentWinRatioConfig?.text!,
                this.isScatterWinPresent(), this._initialWinData.triggerWarriorPay, this._initialWinData.isBigWin);
        }

        // inital win presentation like winbox and betlines will be shown from here
        this.pTimeline.add(() => {
            // 1s seems ok for now
        }, this.pTimeline.totalDuration() + 1);

        this.PresentationState.set(PresentationState.INACTIVE);
    }

    /**
     * #173
     * function to check if scatter is part of win
     * note :- no scatter data availabel in  betline
     */
    private isScatterWinPresent(): boolean {
        let symWinStates: boolean[][] = this._initialWinData.symbolWinStates;
        for (let i = 0; i < symWinStates.length; i++) {
            for (let j = 0; j < symWinStates[i].length; j++) {
                if (symWinStates[i][j] && this._initialWinData.scatterPositions && this._initialWinData.scatterPositions[i] === j) {
                    return true;
                }
            }
        }
        return false;
    }

    /**
     * function to add countup animations and show win field
     */
    private addWinCountupToTimeline(): void {
        if (this._initialWinData.isBigWin) {
            return;
        }
        if (!this._initialWinData.superFreespin && this._initialWinData.currentWinRatioConfig?.text !== WGGameConfig.instance.WIN_RATIOS.normalWin[0].text) { // #326
            WarriorGraveyardGameModuleConfig.background.addThunderAndRailingToBgInSync(this._initialWinData.mode);
        }

        const totalWin: number = this._initialWinData!.singleWin;
        const from: number = 0;
        const duration: number = this._initialWinData!.currentWinRatioConfig!.duration;
        this.pTimeline.add(this._winCountup.getCountUpAnimation(from, totalWin, duration, this._initialWinData.currentMultiplier));
        this.pTimeline.add(() => SlotGame.winFieldController.showWinField());

    }

    /**
     * handling skip too while development in case need this presentation as skippable
     */
    skipPresentation(): void {
        this._winCountup._isCountupAbort = true;
        this.pTimeline.totalProgress(1);
        this.stopPresentation();
    }

    public stopPresentation(): void {
        WarriorGraveyardGameModuleConfig.betlineWinBox.hideAllWinBox();
        WarriorGraveyardGameModuleConfig.betlineWinBox.hideAllBetlines();
        WarriorGraveyardGameModuleConfig.stackAnimationPlayer.hideAllStackAnimation();
        this.resetSymbolAnimation();
        this._winCountup.abort(this._initialWinData!.singleWin, false, this._initialWinData!.currentMultiplier, this._initialWinData!.isBigWin);
    }

    /**
     * reset win symbols animation while skipping the animaitons
     */
    private resetSymbolAnimation(): void {
        for (let reelId = 0; reelId < 6; reelId++) {
            for (let symbolId = 0; symbolId < 3; symbolId++) {
                if (this._initialWinData.symbolWinStates[reelId][symbolId]) {
                    let symbol: WGSpriteSymbol = WGEngineManager.getReel(reelId).getSymbol(symbolId) as WGSpriteSymbol;
                    symbol?.changeState({state: IReelSymbolStates.SHOW});
                }
            }
        }
    }
}